import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "@mui/material";
import { DialogHeader } from "./DialogHeader";
import { MUILoadingButton } from "../buttons/MUILoadingButton";
import { OutlinedButton } from "common/components/buttons/OutlinedButton";
import { useAppraiser } from "../../hooks/auth.hooks";
import { useMutation, useQueryClient } from "react-query";
import { setPropertyAppraiser } from "../../api/api";
import { showToastError } from "common/toast/toast";
import { useTranslation } from "react-i18next";

interface AppraiserMismatchDialogProps {
  open: boolean;
  onClose: () => void;
  onContinue: () => void;
  onAppraiserChanged: () => void;
  propertyId: string;
  currentAppraiserEmail?: string;
  isLoading?: boolean;
}

export const AppraiserMismatchDialog: React.FC<AppraiserMismatchDialogProps> = ({
  open,
  onClose,
  onContinue,
  onAppraiserChanged,
  propertyId,
  currentAppraiserEmail,
  isLoading,
}) => {
  const { data: appraiser } = useAppraiser();
  const { t } = useTranslation();
  
  const queryClient = useQueryClient();

  const { mutate, isLoading: isChangingAppraiser } = useMutation(
    setPropertyAppraiser,
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["appraiserProperties", propertyId]);
        onAppraiserChanged();
      },
      onError: () => {
        showToastError("Nepavyko pakeisti vertintojo");
      },
    }
  );

  const handleChangeAppraiser = () => {
    if (appraiser?._id) {
      mutate({
        propertyId,
        appraiserId: appraiser._id,
      });
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      PaperProps={{
        style: { width: "500px" },
      }}
    >
      <DialogHeader title="Vertintojo neatitikimas" onClose={onClose} />
      <DialogContent style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
        <Typography>
          Šis turtas priskirtas kitam vertintojui. Dabartinis vertintojas:{" "}
          <strong>{currentAppraiserEmail || "-"}</strong>
        </Typography>
        <Typography>
          Pasirinkite, ar norite pakeisti vertintoją į save, ar tęsti be pakeitimų.
        </Typography>
      </DialogContent>
      <DialogActions
        style={{
          padding: "16px 24px",
          display: "flex",
          gap: "12px",
          justifyContent: "flex-end",
        }}
      >
        <OutlinedButton
          onPress={onContinue}
          style={{ width: "150px" }}
          disabled={isLoading || isChangingAppraiser}
        >
          {isLoading ? t("common.loading").toUpperCase() : t("common.continue").toUpperCase()}
        </OutlinedButton>
        <MUILoadingButton
          variant="contained"
          onClick={handleChangeAppraiser}
          disabled={isLoading}
          loading={isChangingAppraiser}
          style={{ width: "180px" }}
        >
          Pakeisti vertintoją
        </MUILoadingButton>
      </DialogActions>
    </Dialog>
  );
};

